import './approve-parts-order.modal.scss';

export default function ApprovePartsOrderModal($scope, $t, close, config, $alert) {
  'ngInject';

  $scope.approvalInfo = config;

  $scope.mapMethodValue = method => {
    if (method) {
      return $t('shared.modals.approve_parts_order.method.' + method);
    }

    return method;
  }

  $scope.ok = (form) => {
    if (!$scope.approvalInfo.paymentMethod) {
      $alert.error($t('shared.modals.approve_parts_order.method_required_error'));
      return;
    }

    if ($scope.approvalInfo.paymentMethod == 'WTN' && !$scope.approvalInfo.wtn) {
      $alert.error($t('shared.modals.approve_parts_order.wtn_required_error'));
      return;
    }

    if (form.$valid) {
      const result = {
        paymentMethod: $scope.approvalInfo.paymentMethod,
        wtn: $scope.approvalInfo.wtn
      };

      close(result);
    }
  }

  $scope.close = () => {
    close(false);
  }
}